import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import Responsive from 'src/_context/Responsive';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions } from 'src/constants/stylesheet';
import Close from './Close';
import PanelCredits from './PanelCredits';
import PanelImage from './PanelImage';
import PanelText from './PanelText';

export type PanelPageProps = PanelPageDto;

const styles = {
    container: {
        position: 'relative',
        [responsive.Mobile]: {
            padding: `0 ${spacing.Gutter.Mobile / 2}px`
        },
        [responsive.Tablet]: {
            minHeight: `calc(100vh - ${spacing.Gutter.Tablet * 2}px)`
        },
        [responsive.Laptop]: {
            minHeight: `calc(100vh - ${spacing.Gutter.Laptop * 2}px)`
        },
        [responsive.Desktop]: {
            minHeight: `calc(100vh - ${spacing.Gutter.Desktop * 2}px)`
        }
        // ...stylesheet.PaddingGutter(.5, directions.sides)
    },
    panel: {
        minHeight: '100%',
        ...stylesheet.PaddingGutter(.5, directions.sides)
    },
    panelPaddingBottom: {
        ...stylesheet.PaddingGutter(1, directions.bottom)
    },
    header: {
        position: 'sticky',
        top: 0,
        ...stylesheet.PaddingGutter(1, directions.top | directions.bottom),
        zIndex: 1
    },
    headerMargin: {
        ...stylesheet.MarginGutter(-0.5, directions.sides)
    },
    title: {
        color: 'black',
        ...stylesheet.PaddingGutter(1, directions.left),
    },
    panelAbsolute: {
        position: 'absolute',
        bottom: '-5px',
        ...stylesheet.PaddingGutter(.5, directions.left)
    },
    panelAbsoluteMobile: {
        [responsive.Mobile]: {
            display: 'none'
        },
    },
    panelHidden: {
        visibility: 'hidden',
        [responsive.Mobile]: {
            visibility: 'initial'
        },
    }
};

type Props =
    PanelPageProps &
    StyledComponentProps<keyof typeof styles>;

class PanelPage extends React.Component<Props> {

    private scrollContainer = document.getElementById("scrollContainer");
    constructor(props: Props) {
        super(props);
    }
    componentDidMount() {

        if (this.scrollContainer && this.scrollContainer.scrollTop > 0) {
            this.scrollContainer.scrollTop = 0;
        }
    }

    componentDidUpdate() {

        if (this.scrollContainer && this.scrollContainer.scrollTop > 0) {
            this.scrollContainer.scrollTop = 0;
        }
    }

    render() {
        const { classes, Panels, Title } = this.props;

        return (
                <div className={classes!.container}>
                    <Responsive.Consumer steps={['Mobile']}>
                        <div className={classNames(classes!.header, classes!.headerMargin)}>
                            <h2 className={classes!.title}>
                                {Title}
                            </h2>
                            <Close />
                        </div>
                    </Responsive.Consumer>
                    {Panels.map((p, i) => {
                        switch (p.type) {
                            case "PanelImage":
                                const panelImage = p as PanelImageDto;
                                return (
                                    <div
                                        key={`box_${i}`}
                                        className={classNames(classes!.panel, classes!.panelPaddingBottom)}
                                    >
                                        <PanelImage {...panelImage} />
                                    </div>
                                );
                            case "PanelText":
                                const panelText = p as PanelTextDto;
                                return (
                                    <div
                                        key={`box_${i}`}
                                        className={classNames(classes!.panel, classes!.panelPaddingBottom)}
                                    >
                                        <PanelText {...panelText} />
                                    </div>
                                );
                            case "PanelCredits":
                                const panelCredits = p as PanelCreditsDto;
                                return (
                                    <React.Fragment>
                                        <div
                                            key={`box_${i}`}
                                            className={
                                                classNames(
                                                    classes!.panel,
                                                    classes!.panelPaddingBottom,
                                                    classes!.panelHidden)}
                                        >
                                            <PanelCredits {...panelCredits} />
                                        </div>
                                        <div
                                            key={`box_${i}`}
                                            className={classNames(classes!.panelAbsolute, classes!.panelAbsoluteMobile)}
                                        >
                                            <PanelCredits {...panelCredits} />
                                        </div>
                                    </React.Fragment>
                                );
                            default:
                                return null;
                        }
                    })}
                </div>
        );
    }
}

export default withStyles(styles)(PanelPage);


// WEBPACK FOOTER //
// ./src/components/PanelPage.tsx